// extracted by mini-css-extract-plugin
export default {"permission-denied":"PermissionDenied_permission-denied__ygL9e"};